import { useSearchParams } from 'react-router-dom';

import { FeatureCreateResume as FeatureCreateResumeView } from './feature-create-resume';
import { CreateResumeProvider } from './create-resume.context';
import {
  CreateResumeStep,
  isCreateResumeStep,
} from './create-resume.store';

const CREATE_RESUME_STEP_QUERY_PARAM = 'step';

export type FeatureCreateResumeProps = {
  initialStep?: CreateResumeStep;
  syncStepWithUrl?: boolean;
};

export const FeatureCreateResume = ({
  initialStep,
  syncStepWithUrl = true,
}: FeatureCreateResumeProps) => {
  if (syncStepWithUrl) {
    return <UrlSyncedFeatureCreateResume initialStep={initialStep} />;
  }

  return (
    <CreateResumeProvider initialStep={initialStep}>
      <FeatureCreateResumeView syncStepWithUrl={false} />
    </CreateResumeProvider>
  );
};

const UrlSyncedFeatureCreateResume = ({
  initialStep,
}: {
  initialStep?: CreateResumeStep;
}) => {
  const [searchParams] = useSearchParams();
  const queryStep = searchParams.get(CREATE_RESUME_STEP_QUERY_PARAM);
  const resolvedInitialStep =
    isCreateResumeStep(queryStep) ? queryStep : initialStep;

  return (
    <CreateResumeProvider initialStep={resolvedInitialStep}>
      <FeatureCreateResumeView syncStepWithUrl />
    </CreateResumeProvider>
  );
};
